import React from "react";
import ReactDOM from "react-dom";
import ReactGA from "react-ga";
import InstagramEmbed from "react-instagram-embed";
import { getURLVal } from "../../domains/URLDomain";
import ReactPixel from "react-facebook-pixel";
import pixelIds from "../../api/fbPixelConfig";
import getIsMobile from "../../common/getIsMobile";
import { FetchModernSlug } from "../../api/payment.api";

class CoachSales extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      coachOrgId: props.route.coachOrgId,
      coachName: null,
      isCheckingRedirect: true,
    };
  }

  componentDidMount = async () => {
    try{
      const modernSlug = await FetchModernSlug(this.state.coachOrgId);
      if (modernSlug) {
        //Redirect to my.trybe.fit
        const newURL = `https://my.trybe.fit/${modernSlug}${window.location.search}`;
        window.location.replace(newURL);
        return;
      }
    } catch(e){
      console.error("Error fetching modern slug:", e);
    }

    this.setState({ isCheckingRedirect: false });

    this.props.actions.paymentActions.fetchProductInfo(this.state.coachOrgId);

    if (this.props.route.tabTitle) {
      document.title = this.props.route.tabTitle;
    }

    if (pixelIds[this.props.route.coachOrgId]) {
      const pixelId = pixelIds[this.props.route.coachOrgId];
      ReactPixel.init(pixelId);
      ReactPixel.pageView();
    }

    this.initAnalytics();

    this.isMobile = getIsMobile();
  };

  initAnalytics = async () => {
    const { coachOrgId } = this.state;
    const coachName = await this.props.actions.analyticsActions.fetchCoachName(
      coachOrgId
    );

    this.setState({
      coachName,
    });
  };

  onClickAppStore = () => {
    ReactGA.outboundLink({
      label: "Clicked App Link",
    });
  };

  renderHeader = () => {
    let sectionsClass = "navbar-section";
    if (this.props.route.navBarColor === "trybe-black") {
      sectionsClass = "navbar-section-black";
    }

    return (
      <div
        className={sectionsClass}
        onClick={() => {
          window.location.href = "https://trybe.fit";
        }}
      >
        <div className="navbar-content">
          <div
            className="logo-container"
            onClick={() => {
              window.location.href = "https://trybe.fit";
            }}
          >
            <img
              className="logo-img"
              src={require("../../images/trybe-logo-white.svg")}
            />
            <div className="logo-text">TRYBE</div>
          </div>
        </div>
      </div>
    );
  };

  renderAppButtons = () => {
    return (
      <a
        className="app-stores-row"
        href={this.props.siteCheckout.get("deepLink")}
        onClick={() => this.onClickAppStore("Clicked App Link")}
      >
        <img
          src={require("../../images/appStore.svg")}
          className="app-store-img"
        />
        <img
          src={require("../../images/googlePlay.svg")}
          className="google-play-img"
        />
      </a>
    );
  };

  renderHeroSection = () => {
    const { salesPage } = this.props;

    const heroImgWeb = salesPage.getIn(["images", "hero"]);
    const heroImgMobile = salesPage.getIn(["images", "mobileHero"]);
    const heroImg = this.isMobile && heroImgMobile ? heroImgMobile : heroImgWeb;

    const mobileImgPosition =
      salesPage.getIn(["heroSection", "mobileImgPosition"]) || null;
    const centerVertically =
      salesPage.getIn(["heroSection", "centerVertically"]) || false;
    const mainText = salesPage.getIn(["heroSection", "mainText"]);
    const mainTextLine2 = salesPage.getIn(["heroSection", "mainTextLine2"]);
    const secondaryText = salesPage.getIn(["heroSection", "secondaryText"]);
    const onlyShowApp = salesPage.getIn(["heroSection", "onlyShowApp"]);

    //allows db to change background-position for mobile
    //so can focus more on either 'left' or 'right'
    let imgClasses = "hero-image";

    if (mobileImgPosition) {
      imgClasses += " mobile-" + mobileImgPosition;
    }

    if (centerVertically) {
      imgClasses += " y-center";
    }

    return (
      <div className="hero-section">
        <div
          className={imgClasses}
          style={{
            backgroundImage: `url(${heroImg})`,
          }}
        >
          <div className="hero-image-overlay" />
          <div className="content">
            <div className="hero-image-text">
              <div className="main-text">{mainText}</div>
              {mainTextLine2 ? (
                <div className="main-text">{mainTextLine2}</div>
              ) : null}
              <div className="secondary-text">{secondaryText}</div>
              {onlyShowApp
                ? this.renderAppButtons()
                : this.renderCheckoutButtons()}
            </div>
          </div>
        </div>
      </div>
    );
  };

  goToCheckout = () => {
    const checkoutLink = this.props.salesPage.get("checkoutLink");
    const queryString = window.location.search;
    const checkoutURL = `/` + checkoutLink + queryString;

    ReactGA.event({
      category: "Purchase",
      action: "Clicked Get Product",
      label: `${this.props.productName}_coachOrgId=${this.state.coachOrgId}`,
    });

    this.props.history.push(checkoutURL);
  };

  renderCheckoutButtons = () => {
    const { salesPage } = this.props;
    const cta = salesPage.getIn(["heroSection", "heroCTA"]) || "Get Program";
    const primaryColor = this.props.salesPage.get("primaryColor");

    return (
      <div className="checkout-btn-row">
        <div
          className="cta-button"
          style={{ backgroundColor: primaryColor }}
          onClick={this.goToCheckout}
        >
          {cta}
        </div>
      </div>
    );
  };

  renderAboutMe = () => {
    const { salesPage } = this.props;
    const header = salesPage.getIn(["aboutMe", "header"]);
    const body = salesPage.getIn(["aboutMe", "body"]);
    const body_2 = salesPage.getIn(["aboutMe", "body_2"]);
    const body_3 = salesPage.getIn(["aboutMe", "body_3"]);
    const body_4 = salesPage.getIn(["aboutMe", "body_4"]);
    const body_5 = salesPage.getIn(["aboutMe", "body_5"]);
    const image = salesPage.getIn(["images", "single"]);

    return (
      <div className="about-me">
        <div className="content">
          <div className="text-section-web">
            <div className="header">{header}</div>
            <div className="body"> {body} </div>
            {body_2 ? <div className="body"> {body_2} </div> : null}
            {body_3 ? <div className="body"> {body_3} </div> : null}
            {body_4 ? <div className="body"> {body_4} </div> : null}
            {body_5 ? <div className="body"> {body_5} </div> : null}
            {this.renderCheckoutButtons()}
          </div>
          <div className="img-section">
            <img src={image} className="about-me-image" />
          </div>
          <div className="text-section-mobile">
            <div className="header">{header}</div>
            <div className="body"> {body} </div>
            {body_2 ? <div className="body"> {body_2} </div> : null}
            {body_3 ? <div className="body"> {body_3} </div> : null}
            {body_4 ? <div className="body"> {body_4} </div> : null}
            {body_5 ? <div className="body"> {body_5} </div> : null}
            {this.renderCheckoutButtons()}
          </div>
        </div>
      </div>
    );
  };

  maybeRenderBanner = () => {
    const { salesPage, siteCheckout } = this.props;
    const text = salesPage.getIn(["banner", "bannerText"]);
    const primaryColor = salesPage.get("primaryColor");
    const showFree = salesPage.get("showFreeDownload");
    const deepLink = siteCheckout.get("deepLink");

    if (!deepLink || !showFree) {
      return (
        <div className="banner" style={{ backgroundColor: primaryColor }}>
          <div className="banner-text">{text}</div>
        </div>
      );
    }

    return (
      <div className="banner" style={{ backgroundColor: primaryColor }}>
        <div className="banner-text">{text}</div>
        {deepLink ? this.renderAppButtons() : null}
      </div>
    );
  };

  renderProgramSummary = () => {
    const { salesPage } = this.props;
    const header = salesPage.getIn(["programSummary", "header"]);
    const highlights = salesPage.getIn(["programSummary", "highlights"]);
    const image = salesPage.getIn(["images", "trifold"]);

    const renderedSum = highlights
      ? highlights.map((val, idx) => {
          return this.renderProgramHighlights(val, idx);
        })
      : null;

    return (
      <div className="program-summary">
        <div className="program-content">
          <div className="img-section">
            <img src={image} className="program-image" />
          </div>
          <div className="program-main">
            <div className="program-text-section">
              <div className="program-header">{header}</div>
              {renderedSum}
            </div>
          </div>
        </div>
      </div>
    );
  };

  renderProgramHighlights = (highlight, idx) => {
    const header = highlight.get("header");
    const description = highlight.get("description");

    return (
      <div className="program-highlight" key={idx}>
        <div className="highlight-header">{header}</div>
        <div className="highlight-description">{description}</div>
      </div>
    );
  };

  renderProgressPics = () => {};

  maybeRenderFooter = () => {
    const deepLink = this.props.siteCheckout.get("deepLink");
    const showFree = this.props.salesPage.get("showFreeDownload");

    if (!deepLink) {
      return null;
    }

    const primaryColor = this.props.salesPage.get("primaryColor");
    const productName = this.props.productName;

    let footerCTA;
    if (productName && showFree) {
      footerCTA = `Try ${productName} free`;
    } else if (showFree) {
      footerCTA = "Try the app free";
    } else if (!showFree) {
      footerCTA = "Already signed up? Download the app here";
    }

    return (
      <div className="footer" style={{ backgroundColor: primaryColor }}>
        <div className="footer-text">{footerCTA}</div>
        {this.renderAppButtons()}
      </div>
    );
  };

  maybeRenderSocial = () => {
    if (getURLVal("ap") !== "trybe") {
      return null;
    }

    if (this.props.salesPage.getIn(["social", "igPosts"])) {
      return (
        <div className="social-section">
          <div className="header">
            {this.props.salesPage.getIn(["social", "header"])}
          </div>
          <div className="posts-section">
            {this.props.salesPage
              .getIn(["social", "igPosts"])
              .map((url) => this.renderSocialPost(url))}
          </div>
        </div>
      );
    }

    return null;
  };

  renderSocialPost = (postUrl) => {
    return (
      <div className="social-content">
        <InstagramEmbed
          url={postUrl}
          clientAccessToken="1671842906403513|864fea21e6e42e4907b559e8f3eca9d4"
          maxWidth={320}
          hideCaption
        />
      </div>
    );
  };

  maybeRenderFAQs = () => {
    const faqs = this.props.salesPage.get("faqs") || null;
    if (!faqs) return null;

    const faqsHeaderText = this.props.salesPage.get("faqsHeader") || "FAQs";

    return (
      <div className="faqs-section">
        <div className="header">{faqsHeaderText}</div>
        <div className="content">
          {faqs.map((val, idx) => {
            if (!val || !val.get) return null;

            return (
              <div key={idx} className="qa-container">
                <div className="question">{val.get("q")}</div>
                <div className="answer">{val.get("a")}</div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  render() {
    return (
      <div className="coach-sales-container">
        {this.renderHeader()}
        {this.renderHeroSection()}
        {this.renderProgramSummary()}
        {this.maybeRenderBanner()}
        {this.renderAboutMe()}
        {this.maybeRenderFAQs()}
        {this.maybeRenderSocial()}
        {this.maybeRenderFooter()}
      </div>
    );
  }
}

export default CoachSales;



// WEBPACK FOOTER //
// ./src/components/coachSalesPages/CoachSalesPage.js